import { render, staticRenderFns } from "./MobileWork.vue?vue&type=template&id=364a287a&scoped=true"
import script from "./MobileWork.vue?vue&type=script&lang=js"
export * from "./MobileWork.vue?vue&type=script&lang=js"
import style0 from "./MobileWork.vue?vue&type=style&index=0&id=364a287a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "364a287a",
  null
  
)

export default component.exports